import { render } from "./addsupplier.vue?vue&type=template&id=d6d92dc8"
import script from "./addsupplier.vue?vue&type=script&lang=js"
export * from "./addsupplier.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-POP-PROD\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__